import { render, staticRenderFns } from "./wxmsgOrg.vue?vue&type=template&id=97327a20&"
import script from "./wxmsgOrg.vue?vue&type=script&lang=js&"
export * from "./wxmsgOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports